export enum ACTIONS {
  RESET_STORE_AUTH = "RESET_STORE_AUTH",
  RESET_STATUS_AUTH = "RESET_STATUS_AUTH",
  RESET_ERROR_AUTH = "RESET_ERROR_AUTH",
  AUTH = "AUTH",
}
